export function SOPSerializer(data){
    if(data)
    return {
        id: data.id,
        created_on: data.created_on,
        docs_used_file_ids: data.docs_used_file_ids,
        docs_used_file_name: data.docs_used_file_name,
        docs_used_file_paths: data.docs_used_file_paths,
        is_completed: data.is_completed,
        master_sop_cost: data.master_sop_cost,
        sop_name: data.sop_name,
        doc_url: data.doc_url,
        message: data.message,
        status: data.status,
        tenant_id: data.tenant_id,
    }
    return null
}

export const SOPListSerializer = (data) => {
    const records= data&&data.content&&data.content.map((doc)=>{
        return SOPSerializer(doc)
    }).filter(obj=>obj)
    if(data)
    return{
        records: records,
        current_page: data.current_page,
        is_first_page: data.is_first_page,
        is_last_page: data.is_last_page,
        is_sorted: data.is_sorted,
        page_size: data.page_size,
        search: data.search,
        sort_order: data.sort_order,
        sorted_column: data.sorted_column,
        total_elements: data.total_elements,
        total_pages: data.total_pages,

    }
    return null
}




